import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'wallet', en);
i18next.addResources('fr', 'wallet', fr);

declare global {
  interface RegisteredLocales {
    wallet: typeof en;
  }
}
